import React, { Component } from 'react';
import { Image, Col, Form, Row, Container, FormControl, Tab, Button, Modal, Accordion, Card} from 'react-bootstrap';
import ManoTarjeta from '../../../img/NewPNG/Terminal.png'
import Arrow from '../../../img/Arrow.svg'
import Puntitos from '../../../img/3circulos.svg'
import BTCIcono from '../../../img/newIcons/CriptoPagos.svg'
import TarjetaCredito from '../../../img/newIcons/TarjetaCredito.svg'
import TarjetaDebito from '../../../img/newIcons/TarjetaDebito.svg'
import Translate from '../../../../../translate'
import axios from 'axios'
import './servicios.css'

class PrincipalBanner extends Component {
	constructor(props) {
		super(props);
		this.state = { 
			country:'',
			countryCode:'',
		}
	}

  componentDidMount(){
    this.getGeoInfo()
  }

	getGeoInfo(){
		axios.get('https://ipapi.co/json/').then((response) => {
			let data = response.data;
			this.setState({
				country: data.country_name,
				countryCode: data.country_code.toLowerCase()
			});
		}).catch((error) => {
			console.log(error);
		});
	}

	handleInputChange(telNumber, selectedCountry) {
		this.setState({country:selectedCountry.name,phone:telNumber,countryCode:selectedCountry.iso2})
	}

	render() {
		return (
			<div className='servicessStructure section-container' id='servicios'>
				<div className='buscas-outter'>
					<Container>
						<div className='mejoresServicios'>
							<Row>
								<Col md={8} className="quitaespacios-container">
									<p className='mysection-title'>{Translate[this.props.lan].landing3.secion2.titulo}</p>
									<p className='myleftsection-Title'>{Translate[this.props.lan].landing3.secion2.subtitulo}</p>
									<p className='myleftsection-link' onClick={()=>window.open(window.location.origin + '/register','_blank')}>
										{Translate[this.props.lan].landing3.hipervinculo}<Image src={Arrow} style={{marginLeft: '15px'}} />
									</p>
								</Col>
								<Col md={4} className="quitaespacios-container">
									<Image src={ManoTarjeta} className='cashImg' />
								</Col>
							</Row>
							<Image src={Puntitos} className='floating-puntitos'/>
						</div>
						<Row style={{justifyContent: 'center'}}>
							<Col sm={12} md={12} lg={4} xl={4} style={{marginTop: "-5px"}}>
								<Row className="align-items-center" style={{marginRight:0, marginLeft:'-3px', justifyContent: 'center'}}>
									<Image src={BTCIcono} className="myIconForColumn" />
									<p style={{marginLeft: '10px'}} className="myColumnsitaTitle">{Translate[this.props.lan].landing3.secion2.cripto}</p>
								</Row>
								<p className='myColumnsitaDescription'>{Translate[this.props.lan].landing3.secion2.criptoDesc}</p>
							</Col>
							{/* <Col sm={12} md={12} lg={4} xl={4}>
								<Row style={{ marginRight:0, marginLeft:0 }}>
									<Image src={TarjetaCredito} className="myIconForColumn"/>
									<p className="myColumnsitaTitle">{Translate[this.props.lan].landing3.secion2.credito}</p>
								</Row>
								<p className='myColumnsitaDescription'>{Translate[this.props.lan].landing3.secion2.creditoDesc}</p>
							</Col>
							<Col sm={12} md={12} lg={4} xl={4}>
								<Row style={{marginRight:0, marginLeft:0}}>
									<Image src={TarjetaDebito} className="myIconForColumn"/>
									<p className="myColumnsitaTitle">{Translate[this.props.lan].landing3.secion2.debito}</p>
								</Row>
								<p className='myColumnsitaDescription'>{Translate[this.props.lan].landing3.secion2.debitoDesc}</p>
							</Col> */}
						</Row>
					</Container>
				</div>
			</div>
		);
	}
}

export default PrincipalBanner;
